import { ChangeOrderDeliveryStatusPartiallyByMarkerRequest } from '@/Api/MpOrdersMarking/Requests/ChangeOrderDeliveryStatusPartiallyByMarkerRequest';
import { DateFormatType, OrderMarker, OrderStatusFilterGroups } from '@/Enums';
import { useForm } from '@/Hooks/useFormWrapper';
import { useRequired } from '@/Hooks/Validation';
import { dateTimeUtils } from '@/Utils/DateTimeUtils';
import { useCallback } from 'react';
import { salesPageActions } from 'src/Pages/Sales/services';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@/Redux/ConfigureStore';
import { changeDeliveryAsyncActions } from '../services/asyncActions';
import { BaseResponse } from '@/Api';

type FormData = ChangeOrderDeliveryStatusPartiallyByMarkerRequest;

export const useShippedAndNotShippedForm = (orderIds: number[], onClose: () => void) => {
  const dispatch: AppDispatch = useDispatch();

  const {
    register,
    watch,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    defaultValues: {
      orderIds,
      orderMarker: OrderMarker.Shipped,
      overwritePreviousDates: false,
      shippingDate: dateTimeUtils.getCurrentDateTime(DateFormatType.LOCAL_DATE_TIME),
    },
  });

  // variables
  const needShowDate = watch('orderMarker') === OrderMarker.Shipped;

  // rules
  const required = useRequired();
  const dateRequired = useRequired(needShowDate);

  const submit = useCallback(
    (data: FormData) => {
      onClose();

      dispatch(
        changeDeliveryAsyncActions.changeDeliveryStatusPartially({
          ...data,
          shippingDate: dateTimeUtils.localStringToUtcString(data?.shippingDate),
        }),
      ).then((response) => {
        if (!(response.payload as BaseResponse).errors) {
          const markerToGroupMap = {
            [OrderMarker.NotShipped]: OrderStatusFilterGroups.NotShippedGroup,
            [OrderMarker.Shipped]: OrderStatusFilterGroups.ShippedGroup,
          };

          // If data.marker is shipped and filters is not shipped remove orders
          dispatch(
            salesPageActions.removeOrdersFromStateByCurrentFilters({
              orderIds: orderIds,
              filters: markerToGroupMap[data.orderMarker as keyof typeof markerToGroupMap] ?? [],
            }),
          );
        }
      });
    },
    [orderIds],
  );

  return {
    methods: {
      register,
      setValue,
      onSubmit: handleSubmit(submit),
    },
    errors,
    needShowDate,
    rules: {
      required,
      dateRequired,
    },
  };
};
